import { useSelector } from 'react-redux';

const useUsers = () => {
  const { users, userPagination } = useSelector((state) => state.usersSlice);

  return {
    users,
    pagination: userPagination,
  };
};

export default useUsers;
